import { isCIS } from '~/settings';
import { t } from '~/helpers/localization';

export const clanBattlesDescription = {
  title: t('Клановые бои'),
  items: [
    t('Клановый бой проводится между двумя отрядами на кораблях одного уровня.'),
    t('В течение сезона клановые бои проводятся в среду, четверг, субботу и воскресенье в определённое время.'),
    ...isCIS([], [t('Участвуя в клановых боях, вы можете сразиться с игроками из других регионов.')]),
    t('Существует 5 лиг: Шквала, Бури, Шторма, Тайфуна и Урагана. Кланы распределены в лигах по рейтингу.'),
    t('Побеждая в клановых боях, вы повышаете рейтинг вашего клана, проигрывая - понижаете.'),
    t('За победы в клановых боях вы будете получать сталь и другие ценные награды.'),
    isCIS(
      t(
        'С завершением сезона, кланы, занявшие определённые места в рейтинге региона, получат соответствующие награды в клановую казну.',
      ),
      t(
        'С завершением сезона, кланы, занявшие определённые места в глобальном рейтинге, получат соответствующие награды в клановую казну.',
      ),
    ),
  ],
};
